import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { SenderEmailViewModel } from '@app/@core/models';
import { DxFormComponent } from 'devextreme-angular';

@Component({
  selector: 'app-forgot-password-form',
  templateUrl: './forgot-password-form.component.html',
  styleUrls: ['./forgot-password-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ForgotPasswordFormComponent implements OnInit {
  @Input() senderEmail!: SenderEmailViewModel;
  @Input() loading!: boolean;
  @Input() error!: string;
  @Output() submit = new EventEmitter();

  @ViewChild(DxFormComponent) loginForm!: DxFormComponent;

  submitted = false;

  constructor() {
    this.onSubmit = this.onSubmit.bind(this);
    this.onEnterKey = this.onEnterKey.bind(this);
  }

  ngOnInit(): void {}

  onEnterKey(e) {
    this.submitted = true;
    const { isValid } = this.loginForm.instance.validate();
    if (isValid) {
      this.submit.emit({
        correo: this.senderEmail.email,
      });
    }
  }

  onSubmit(e) {
    this.submitted = true;
    const { isValid } = this.loginForm.instance.validate();
    if (isValid) {
      this.submit.emit({
        correo: this.senderEmail.email,
      });
    }
  }
}
